'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../../components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _YellowLineSVG = require('../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _faExclamationTriangle = require('@fortawesome/free-solid-svg-icons/faExclamationTriangle');

var _config = require('../../config.js');

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Subtitle = require('./components/Subtitle');

var _Subtitle2 = _interopRequireDefault(_Subtitle);

var _CTAAlert = require('./components/CTAAlert');

var _CTAAlert2 = _interopRequireDefault(_CTAAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLOR_MAP = {
  black: _config.colors.black,
  white: _config.colors.white
};

/**
# CardCTA
A card CTA with copy & a button link.
 */
var CardCTA = function CardCTA(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      buttonLabel = _ref.buttonLabel,
      buttonLink = _ref.buttonLink,
      _ref$hasBackground = _ref.hasBackground,
      hasBackground = _ref$hasBackground === undefined ? true : _ref$hasBackground,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? _config.colors.black : _ref$color,
      _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === undefined ? 'primary' : _ref$buttonType,
      _ref$needsAttention = _ref.needsAttention,
      needsAttention = _ref$needsAttention === undefined ? false : _ref$needsAttention,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === undefined ? true : _ref$isValid;
  return _react2.default.createElement(
    _Wrapper2.default,
    {
      $hasBackground: hasBackground,
      color: COLOR_MAP[color],
      $isValid: isValid
    },
    _react2.default.createElement(_YellowLineSVG2.default, null),
    _react2.default.createElement(
      _Title2.default,
      null,
      title
    ),
    _react2.default.createElement(
      _Subtitle2.default,
      { $alertShowing: needsAttention },
      subTitle
    ),
    needsAttention && _react2.default.createElement(
      _CTAAlert2.default,
      null,
      _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faExclamationTriangle.faExclamationTriangle }),
      ' Needs Attention'
    ),
    isValid && _react2.default.createElement(
      _Button2.default,
      {
        onClick: function onClick() {
          return window.location.assign('' + buttonLink);
        },
        variant: buttonType
      },
      buttonLabel
    )
  );
};

CardCTA.propTypes = {
  /** title. */
  title: _propTypes2.default.string.isRequired,
  /** subtitle. */
  subTitle: _propTypes2.default.string.isRequired,
  /** label for the button. */
  buttonLabel: _propTypes2.default.string.isRequired,
  /** link to navigate to when the button is pressed. */
  buttonLink: _propTypes2.default.string.isRequired,
  /** boolean to set a background or not. */
  hasBackground: _propTypes2.default.bool,
  /** whether or not this CTA should be valid based on permissions */
  isValid: _propTypes2.default.bool,
  /** text color. */
  color: _propTypes2.default.string,
  /** button type. */
  buttonType: _propTypes2.default.oneOf(['primary', 'primaryBig', 'secondary']),
  needsAttention: _propTypes2.default.bool
};

CardCTA.displayName = 'CardCTA';

exports.default = CardCTA;
CardCTA.__docgenInfo = {
  'description': '# CardCTA\r\nA card CTA with copy & a button link.',
  'methods': [],
  'displayName': 'CardCTA',
  'props': {
    'hasBackground': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'boolean to set a background or not.'
    },
    'color': {
      'defaultValue': {
        'value': 'colors.black',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'text color.'
    },
    'buttonType': {
      'defaultValue': {
        'value': '\'primary\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'primary\'',
          'computed': false
        }, {
          'value': '\'primaryBig\'',
          'computed': false
        }, {
          'value': '\'secondary\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'button type.'
    },
    'needsAttention': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'isValid': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'whether or not this CTA should be valid based on permissions'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'title.'
    },
    'subTitle': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'subtitle.'
    },
    'buttonLabel': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'label for the button.'
    },
    'buttonLink': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'link to navigate to when the button is pressed.'
    }
  }
};